import React from "react"
import { Row, Col } from "reactstrap"
import { connect } from 'react-redux';
import {Link} from "react-router-dom"
import {
  Sparklines,
  SparklinesBars,
} from "react-sparklines"
import { useEffect } from "react";
import { useState } from "react";
import { apiEndpoint } from "helpers/url_helper";
import ReactBSAlert from "react-bootstrap-sweetalert";
import { Redirect } from "react-router-dom"
import { createBrowserHistory } from 'history';
import { useHistory } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';    
import "react-toastify/dist/ReactToastify.css"; 
import sound from "assets/audio/notification.mp3"
import { isArray, last } from "lodash";
const Breadcrumb = props => {
  const [violationsCnt, setviolationCnt] = useState([]);
  const [alertmsg, setAlert] = useState([]);
  const [notificationmsg, setnotifications] = useState([]);
 
  const itemLength = (props.breadcrumbItems || []).length || 1;
  var violationsStrng="";
  var violations;
  var notifications;
  let history = useHistory();
  const audio = new Audio(sound);
 useEffect(() => {
  var interval=sessionStorage.getItem("breadcrumbsession");
  clearInterval(interval)

  const getData = async () => {
    // UserValidated
    const urlNotify=  apiEndpoint+'/GetLiveNotifications';
    try {
      const response = await fetch(urlNotify, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json', 
      },
        body: JSON.stringify({
          "Token": sessionStorage.getItem("Clear_AuthUser")
      })
      });

      if(response.body!=null){
        const data = await response.json();
        if(data.status){
         console.log(data) 
         if(data.Notifications!=undefined && data.Notifications!='[]'){
          notifications=JSON.parse(data.Notifications);
          setlivenotifications(notifications);  
         }
        }
        else{
          if(data.Message!=null){
          setAlert (
            <ReactBSAlert
              warning
              title="Warning"
              onConfirm={() => SessionExpired()}
              onCancel={() => setAlert(null)}
              confirmBtnBsStyle="info"
            >
              {data.Message}
            </ReactBSAlert>
          )
          // setTimeout(() => {
          //   SessionExpired();
          // }, 5000);
        }}
      }
    } catch (error) {
        console.log(error);
    }

    // UserValidated
    const url = apiEndpoint+'/GetTodaysViolationsForUser';
    setAlert(null)
    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json', 
      },
        body: JSON.stringify({
          "Token": sessionStorage.getItem("Clear_AuthUser")
      })
      });

      if(response.body!=null){
        const data = await response.json();
        if(data.status){
          if(data.Violations!=undefined){
          violations=JSON.parse(data.Violations);
          setViolationData(violations,0);   
          }
        }
        else{
          if(data.Message!=null){
          setAlert (
            <ReactBSAlert
              warning
              title="Warning"
              onConfirm={() => SessionExpired()}
              onCancel={() => setAlert(null)}
              confirmBtnBsStyle="info"
            >
              {data.Message}
            </ReactBSAlert>
          )
          // setTimeout(() => {
          //   SessionExpired();
          // }, 5000);
        }}
      }
    } catch (error) {
        console.log(error);
    }

  
  };
  getData();
 var t= setInterval(() => {
    getData();
    var interval=sessionStorage.getItem("breadcrumbsession");
  clearInterval(interval)

  }, 30000);

 
}, [props.intUserID]);

const SessionExpired = () => {
  console.log("SessionExpired Called");

  const response = fetch(apiEndpoint+'/Logout', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json', 
  },
    body: JSON.stringify({
      "Token": sessionStorage.getItem("Clear_AuthUser")
  })
  });
  
  // sessionStorage.removeItem("authUser")
  // sessionStorage.removeItem("userFullName")
    // sessionStorage.removeItem("authUser")
    sessionStorage.removeItem("userFullName")
    sessionStorage.removeItem("Clear_AuthUser")
    sessionStorage.removeItem("GetToChange")
  setAlert(null)
  history.push('/');
}

function setViolationData(violations, i) {
 var t= setInterval(    
      function () {    
    violationsStrng=violations[i].CampusName+ " : " + violations[i].intViolationsCnt +"  ";
     setviolationCnt(violationsStrng)
           i++;
           i %= violations.length;
           
           if(i==violations.length){
            i=0;
           }
     },   
     2000   
      
   ); 
   
   sessionStorage.setItem("breadcrumbsession",t)

 }
 function setlivenotifications(notifications) {
console.log(notifications.length)
var lastNotId;
var arr=[];
for(var i=0; i <notifications.length;i++){
  
  if(sessionStorage.getItem("LastNotificationID")!=null){
   lastNotId=JSON.parse( sessionStorage.getItem("LastNotificationID"))
   console.log(lastNotId)
  }
  if(lastNotId!=undefined){
  if(!(lastNotId.includes(notifications[i].NotificationID) )){
        var msg;   
        if(notifications[i].IncidentDescription==null){
          notifications[i].IncidentDescription="";
        }
        if(notifications[i].IncidentDescription=="OverSpeed"){
        msg=notifications[i].IncidentDescription + ' Violation occured at Campus:' + notifications[i].Campus + ', Location:'+notifications[i].LocationName+' , at time ' +  new Date(notifications[i].UpdatedAt.replace('T', ' ').replace('Z', '')).toLocaleString()  +' with speed of '+notifications[i].VehicleSpeed+'.';
        }
        else {
          msg=notifications[i].IncidentDescription + ' Violation occured at Campus:' + notifications[i].Campus + ', Location:'+notifications[i].LocationName+' , at time ' +  new Date(notifications[i].UpdatedAt.replace('T', ' ').replace('Z', '')).toLocaleString()  + '.';
        }
      setnotifications(msg)
      toast.info(msg,{ position: toast.POSITION.TOP_RIGHT,autoClose:15000})
     
      audio.loop = false;
      audio.play();
      }   
    }
    else{
      var msg;   
        if(notifications[i].IncidentDescription==null){
          notifications[i].IncidentDescription="";
        }
        if(notifications[i].IncidentDescription=="OverSpeed"){
        msg=notifications[i].IncidentDescription + ' Violation occured at Campus:' + notifications[i].Campus + ', Location:'+notifications[i].LocationName+' , at time ' +  new Date(notifications[i].UpdatedAt.replace('T', ' ').replace('Z', '')).toLocaleString()  +' with speed of '+notifications[i].VehicleSpeed+'.';
        }
        else {
          msg=notifications[i].IncidentDescription + ' Violation occured at Campus:' + notifications[i].Campus + ', Location:'+notifications[i].LocationName+' , at time ' +  new Date(notifications[i].UpdatedAt.replace('T', ' ').replace('Z', '')).toLocaleString()  + '.';
        }
      setnotifications(msg)
      toast.info(msg,{ position: toast.POSITION.TOP_RIGHT,autoClose:15000})
    
      audio.loop = false;
      audio.play();
    }
   
    arr.push(notifications[i].NotificationID)
    console.log(arr)
    console.log(JSON.stringify(arr))
console.log(i)

  }
  sessionStorage.setItem("LastNotificationID",JSON.stringify(arr))
  }
  
  return (
    <Row>
      <Col sm={6}>
        <div className="page-title-box">

          <h4>{props.title}</h4>
          <ol className="breadcrumb m-0">
            {
              (props.breadcrumbItems || []).map((item, key) =>
                (key + 1) === itemLength ?
                  <li key={key} className="breadcrumb-item active">{item.title}</li>
                  : <li key={key} className="breadcrumb-item"><Link to="#">{item.title}</Link></li>
              )
            }
          </ol>
        </div>
      </Col>

      <Col sm={6}>
        <div className="state-information d-none d-sm-block">
          <div className="state-graph">
          {alertmsg}
            <div className="info" style={{fontWeight:"bold"}}>Today's Violations</div>
            <Sparklines
              data={[8, 6, 4, 7, 10, 12, 7, 4, 9, 12, 13, 11, 12]}
              margin={3}
              svgWidth={101}
              svgHeight={32}
            >
              <SparklinesBars
                margin={3}
                style={{
                  strokeWidth: 5,
                  stroke: "#7A6FBE",
                  fill: "#7A6FBE"
                }}
              />
            </Sparklines>
            <div className="info"style={{fontWeight:"bold"}}>{violationsCnt} </div>
          </div>
          <ToastContainer />
        </div>
      </Col>
      
    </Row>
  )
}

const mapStatetoProps = state => {
  const Layout = state.Layout;
  const BreadcrumbData = state.Breadcrumb
  return { layoutType: Layout.layoutType, title: BreadcrumbData.title, breadcrumbItems: BreadcrumbData.breadcrumbItems };
};

export default connect(mapStatetoProps, {})(Breadcrumb);
